module.exports = __webpack_public_path__ + "img/tree_right_2.b3c75573.png";